module.exports = __webpack_public_path__ + "img/logo2.a9222785.png";